import { Component, Signal, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AppConstants } from 'src/app/constants/app-constants';
import { ApplicationsPageComponent } from '../applications-page/applications-page.component';
import { InvitePageComponent } from '../invite-page/invite-page.component';
import { DialogService } from "../../services/dialog/dialog.service";
import { UserService } from 'src/app/services/user/user.service';

/**
 * ApplicationsPage represenents the 'applications' menu
 */
@Component({
    selector: 'app-applications-and-invites',
    templateUrl: './applications-and-invites-page.component.html',
    styleUrl: './applications-and-invites-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ApplicationsAndInvitesPageComponent {

  /** Flag on if user is suspended */
  public isSuspended!: boolean;

  @ViewChild(InvitePageComponent) invitePage!: InvitePageComponent;
  @ViewChild(ApplicationsPageComponent) applicationsPage!: ApplicationsPageComponent;
  public title = AppConstants.TITLE_APPLICATIONS_INVITES;

  constructor(
    private readonly _dialogService: DialogService,
    private readonly _userService: UserService,
  ) {
    const companyStatus = this._userService.company?.companyStatus;
    this.isSuspended = companyStatus === 'suspended';
  }

  newApp() {
    this._dialogService.openNewApp();
  }

  export(table: Signal<string | undefined>) {
    switch (table()) {
      case 'invites':
        this.invitePage.exportInvitationsToExcel();
        break;
      case 'applications':
        this.applicationsPage.exportApplicationsToExcel();
        break;
    }
  }
}
